import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04454cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "form__select-wrapper" }
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = {
  value: "",
  selected: "",
  hidden: "",
  disabled: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form__select-icon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "form__label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        class: _normalizeClass(["form__input form__select", _ctx.getValidationClass]),
        id: _ctx.id,
        value: _ctx.modelValue,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }, [
        _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.placeholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.id,
            key: option.id
          }, _toDisplayString(option.title), 9, _hoisted_6))
        }), 128))
      ], 42, _hoisted_4),
      _hoisted_7,
      (_ctx.validationError === 'valid')
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: ['fas', 'check-circle'],
            class: "form__input-validation-icon form__input-validation-icon--valid-select"
          }))
        : _createCommentVNode("", true),
      (_ctx.validationError === 'invalid')
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 1,
            icon: ['fas', 'exclamation-circle'],
            class: "form__input-validation-icon form__input-validation-icon--invalid-select"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}